import React, { useEffect, useState } from "react";
import { Alert } from "reactstrap";
import {
    accountPushEnabledLocally,
    disableAccountWebPush,
    enableAccountWebPush,
    webPushSupported
} from "services/WebPush";
import { useAccountTranslation } from "./translations";

interface Props {
    accountId: string;
}

const AccountPushNotifications: React.FC<Props> = ({ accountId }) => {
    const { t } = useAccountTranslation();
    const [enabled, setEnabled] = useState(false);
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState("");
    const supported = webPushSupported();

    useEffect(() => {
        setEnabled(accountPushEnabledLocally(accountId));
    }, [accountId]);

    const toggle = async () => {
        setBusy(true);
        setMessage("");
        try {
            if (enabled) {
                await disableAccountWebPush(accountId);
                setEnabled(false);
                setMessage(t("pushDisabled"));
            } else {
                await enableAccountWebPush(accountId);
                setEnabled(true);
                setMessage(t("pushEnabled"));
            }
        } catch (error) {
            setMessage(Notification.permission === "denied" ? t("pushPermissionDenied") : t("pushUpdateError"));
        } finally {
            setBusy(false);
        }
    };

    return <div className="portal-setting-control">
        <div className={`portal-setting-status${enabled ? " portal-setting-status--enabled" : ""}`}>
            <span><i className={`mdi ${enabled ? "mdi-bell-check-outline" : "mdi-bell-off-outline"}`} /></span>
            <div>
                <strong>{enabled ? t("pushEnabled") : t("pushDisabled")}</strong>
                <small>{supported ? t("notificationSettingsDescription") : t("pushUnsupported")}</small>
            </div>
        </div>
        <button
            type="button"
            className={`portal-button ${enabled ? "portal-button-secondary" : "portal-button-primary"}`}
            disabled={busy || !supported}
            onClick={toggle}
        >
            {busy ? "…" : enabled ? t("pushDisable") : t("pushEnable")}
        </button>
        {message && <Alert className="w-100 mb-0 mt-3" color={enabled ? "success" : "info"}>{message}</Alert>}
    </div>;
};

export default AccountPushNotifications;
